var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.slug,staticClass:"tabs__panel",class:{'tabs__panel--active': _vm.active},attrs:{"data-slug":_vm.slug}},[_vm._t("default",null,{"active":_vm.active})],2)}
var staticRenderFns = []

export { render, staticRenderFns }